import React, { PropTypes } from 'react';
import classNames from 'classnames';
import PointMap from 'components/googleMap/pointMap';
import StaticMap from 'components/googleMap/staticMap';
import JournalHeader from './journalHeader';

class JournalEntry extends React.Component {

    constructor(props) {
        super(props);
    }

    onDelete = () => {
        var self = this;

        if (self.props.detail &&
            self.props.detail.id &&
            self.props.onDelete &&
            window.confirm('Are you sure you want to delete this entry?')) {
            self.props.onDelete(self.props.detail.id);
        }
    }

    render() {
        var self = this,
            checkin = self.props.detail,
            isAuthenticated = !!self.props.currentUser,
            containerClass,
            footerRowClass,
            actions,
            description;

        containerClass = classNames('card journal-entry', {
            'journal-entry-draft': checkin.isDraft
        });

        footerRowClass = classNames('card-text nowrap journal-entry-footer-text', {
            'col-xs-7': isAuthenticated,
            'col-xs-12': !isAuthenticated
        });

        if (isAuthenticated) {
            actions = (
                <div className="journal-entry-actions nowrap">
                    <a className="btn btn-primary" href={ `/checkin/${checkin.id}` }>
                        <i className="fa fa-pencil-square-o"></i>
                    </a>
                    <a className="btn btn-danger" href="javascript:void(0)" onClick={ self.onDelete }>
                        <i className="fa fa-close"></i>
                    </a>
                </div>
            );
        }

        if (checkin.description != null && checkin.description !== '') {
            description = (
                <div className="card-block journal-entry-content">
                    <div className="card-text" dangerouslySetInnerHTML={ { __html: checkin.html || checkin.description } }></div>
                </div>
            );
        }

        return (
            <div className={ containerClass } key={ checkin.id } data-id={ checkin.id }>
                <div className="card-media">
                    <JournalHeader checkin={ checkin } />
                </div>

                { description }

                <footer className="card-footer container journal-entry-footer">
                    <div className="row">
                        <div className={ footerRowClass }>
                            <i className="fa fa-map-o"></i>
                            &nbsp;
                            <a href={ checkin.place.url } target="_blank" title={ 'Visit ' + checkin.place.name + ' on Google Maps' }>{ 'Explore ' + checkin.place.name }</a>
                        </div>
                    </div>
                    <div className="row">
                        <div className={ footerRowClass }>
                            <span className="text-muted">{ new Date(checkin.date).toLocaleString() }</span>
                        </div>
                    </div>

                    { actions }
                </footer>
            </div>
        );
    }
};

export default JournalEntry;


// WEBPACK FOOTER //
// ./src/app/components/journal/journalEntry.jsx